import styled from 'styled-components';

export const PopoverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .ant-btn-text {
    span {
      font-weight: 400 !important;
    }
  }
`;
